import styled from '@emotion/styled';

export const MarkerDetailTitle = styled('h2')(({ active }) => ({
  flex: 1,
  color: 'white !important',
  margin: 0,
  padding: '15px',
  paddingRight: '130px',
  fontSize: '20px',
  backgroundColor: active ? '#f05a28' : '#1063AC',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
}));
